import React, { Component } from "react";
import { connect } from "react-redux";

var QRCode = require('qrcode');

class Intro extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
    }

    render() {
        return (
            <div className="bg">

                {/* <div className="logo text-center">
                      <img src="../assets/images/logo.png" alt=""  className="logo-img" />
                </div> */}

                <div className="wrapper">
                    <form action="#" id="wizard" className="wizard clearfix">
                        <h4>
                        </h4>
                        <div className="logo text-center">
                            <img src="../assets/images/NOVA-1.png" alt="" className="logo-img" />
                        </div>
                        <section>
                            <div className="inner">
                                <div className="image-holder">
                                    <img src="../assets/wizard/images/Receive_Coin_new.png" alt="" />
                                    <div className="ready">
                                        <a className="sw-btn-skip" href="/login"> Skip prompts and enter Nova Wallet </a>
                                    </div>
                                </div>
                                <div className="form-content">
                                    <div className="form-inner form-inner-last">
                                        <div className="form-header">
                                            <h3>Nova Wallet</h3>
                                            <p className="text-2">Save your Nova Web Wallet securely using the existing paper wallet method. This helps you to recover your coins in case of any emergency. Remember to backup your recovery phrase!</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </section>

                        <h4></h4>
                        <section>
                            <div className="inner">
                                <div className="image-holder">
                                    <img src="../assets/wizard/images/Receive_Coin_new.png" alt="" />
                                    <div className="ready">
                                        <a className="sw-btn-skip" href="/login"> Skip prompts and enter Nova Wallet </a>
                                    </div>
                                </div>
                                <div className="form-content">
                                    <div className="form-inner form-inner-last">
                                        <div className="form-header">
                                            <h3> Receive Coins</h3>
                                            <p className="text-2">

                                                Conveniently scan the QR code provided to gather the receiving address and share with other Nova Wallet users!
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>

                        <h4></h4>
                        <section>
                            <div className="inner">
                                <div className="image-holder">
                                    <img src="../assets/wizard/images/Receive_Coin_new.png" alt="" />
                                    <div className="ready">
                                        <a className="sw-btn-skip" href="/login"> Skip prompts and enter Nova Wallet </a>
                                    </div>
                                </div>
                                <div className="form-content">
                                    <div className="form-inner form-inner-last">
                                        <div className="form-header">
                                            <h3> Send Coins</h3>
                                            <p className="text-2"> You can instantly send your coins using Nova Wallet. Simply scan the QR code or type the recipient address to send.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </form>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
}
export default connect(mapStateToProps)(Intro);





